import { Component, ViewChild } from '@angular/core';
import { FormGroup, FormControl, Validator, Validators, ControlValueAccessor, AbstractControl, ValidationErrors, NG_VALUE_ACCESSOR, NG_VALIDATORS } from '@angular/forms';
import { TextBoxComponent } from "@progress/kendo-angular-inputs";


@Component({
  selector: 'password-input',
  styles: [`      
    form {
      display: flex;
      flex-direction: column;
    }    
    .k-textbox-container, .k-textbox {
      width: 100%;
    }    
  `],
  template: `   
  
    <!--{{ _form.value | json }}-->

    <form [formGroup]="_form">
      <kendo-textbox #textbox [clearButton]="true" formControlName="password" (valueChange)="valueChange($event)">
        <ng-template kendoTextBoxSuffixTemplate>
          <button kendoButton look="clear" [icon]="'eye'"(click)="togglePass($event)"></button>
        </ng-template>
      </kendo-textbox>
    </form>
    
  `,  
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      multi:true,
      useExisting: PasswordInputComponent
    }     
  ]
})
export class PasswordInputComponent implements ControlValueAccessor {  

  @ViewChild("textbox", {static: false}) public textbox: TextBoxComponent;

  //Input: value
  protected _value : string = '';

  public _form!: FormGroup;

  //@Override
  protected onChange = (value: any) => {};

  //@Override
  protected onTouched = () => {};

  //@Override
  protected touched = false;

  //@Override
  protected disabled = false;

  //@Override
  public writeValue(value: string) {
    this._value = value;

    this._form = this.getFormGroup({
      password: this._value
    });
  }

  //@Override
  public registerOnChange(onChange: any) {
    this.onChange = onChange;
  }

  //@Override
  public registerOnTouched(onTouched: any) {
    this.onTouched = onTouched;
  }

  //@Override
  protected markAsTouched() {
    if (!this.touched) {
      this.onTouched();
      this.touched = true;
    }
  }

  //@Override
  public setDisabledState(disabled: boolean) {
    this.disabled = disabled;
  }

  //@Override
  // public validate(control: AbstractControl): ValidationErrors | null {
  //   const value = control.value;
  //   if (value.length > 0) {
  //     return {
  //       required: {
  //         value
  //       }
  //     };
  //   }
  // }

  // @Output() selected = new EventEmitter<any>();
  
  constructor() {
    this._form  = this.getFormGroup(); 
  }

  public ngAfterViewInit(): void {
    this.textbox.input.nativeElement.type = "password";
  }

  public togglePass(e: any): void {
    // console.log(e.pointerType, e.target.nodeName, e);
    // e.stopPropagation();
    const inputEl = this.textbox.input.nativeElement;

    if (e.pointerType === 'mouse' && e.target.nodeName === 'SPAN') {
      if (inputEl.type === "password") {
        inputEl.type = "text";
      } else {
        inputEl.type = "password";
      }
    }

    // console.log(this._form.controls.password.value);
  }

  protected getFormGroup(dataItem?: any): FormGroup {

    return new FormGroup({
      'password': new FormControl("", [Validators.required]),
    });

  };

  get f() { 
    
    return this._form.controls; 
  
  }

  public valueChange(value: any): void {

    this.markAsTouched();
    if (!this.disabled) {
      this._value = value;
      // let item = this._form.value;
      // this._value = item.grados + (item.minutos / 60) + (item.segundos / 3600) ;
      this.onChange(this._value);
    }

  }

}
